import React from 'react'
import { UserPanel } from '../../organisms/UserPanel'
import { ContentWrap, LoginPageVisitUs } from '../../../App/App.styled'
import { MainScreen } from '../../organisms/MainScreen'
import { ProfileHeaderMobile } from '../../molecules/ProfileHeaderMobile'
import { useAuth } from '../LoginPage/login.store'

export type MainPageProps = {
  onClickChangePassword: () => void
}

export const MainPage = ({ onClickChangePassword }: MainPageProps) => {
  const auth = useAuth()

  if (!auth.isAuth) {
    return <>Could not load data</>
  }

  let linkText;
  if (window.location.host=='employee.immidee.com'){
	linkText = <LoginPageVisitUs href="https://www.golawcorp.com" target="_blank">www.golawcorp.com</LoginPageVisitUs>;
  } else if (window.location.host=='reinhorn-employee.immidee.com'){
	//linkText = <LoginPageVisitUs href="https://www.reinhornlaw.com" target="_blank">www.reinhornlaw.com</LoginPageVisitUs>;
	linkText = "";
  } else if (window.location.host=='app.staging.employee.immidee.com'){
	linkText = <LoginPageVisitUs href="https://www.immidee.tech" target="_blank">www.immidee.tech</LoginPageVisitUs>;
  } else {	
	linkText = <LoginPageVisitUs href="https://www.immidee.tech" target="_blank">www.immidee.tech</LoginPageVisitUs>;
  }
  
  return (
    <>
      <ProfileHeaderMobile
        userId={auth.employeeId}
        onClickChangePassword={onClickChangePassword}
      />
      <UserPanel
        userId={auth.employeeId}
        onClickChangePassword={onClickChangePassword}
      />
      <ContentWrap>
        <MainScreen userId={auth.employeeId} />
      </ContentWrap>
	  <div>
	    {linkText}
	  </div>
    </>
  )
}
